import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from "react";
import { Button, makeStyles, Typography, RaiseColors, Icon } from "componentLibrary";
import { Menu, MenuItem } from "client/componentLibrary";
import classNames from "classnames";
import { getCategoryPillWidth } from "client/Listings/ListingsFilters/ListingsCategoryBar";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PillVariantColors = {
  filter: {
    selected: RaiseColors.white,
    unselected: RaiseColors.gray300
  },
  royalPurple: {
    selected: RaiseColors.white,
    unselected: RaiseColors.white,
    background: RaiseColors.midnight,
    hover: RaiseColors.midnight,
    hoverText: RaiseColors.white
  },
  category: {
    selected: RaiseColors.peach,
    unselected: RaiseColors.gray300,
    hover: RaiseColors.peach,
    hoverText: RaiseColors.white,
    borderHover: RaiseColors.peach
  },
  dealroom: {
    selected: RaiseColors.black,
    unselected: RaiseColors.gray300,
    hover: RaiseColors.white,
    hoverText: RaiseColors.black,
    borderHover: RaiseColors.black
  },
  workplaceos: {
    selected: RaiseColors.black,
    unselected: RaiseColors.black,
    hover: RaiseColors.white,
    hoverText: RaiseColors.black,
    borderHover: RaiseColors.jllRed
  },
  enabled: {
    selected: RaiseColors.success700,
    unselected: RaiseColors.success700,
    hover: RaiseColors.success100,
    hoverText: RaiseColors.success700,
    background: RaiseColors.success100
  },
  disabled: {
    selected: RaiseColors.neutral500,
    unselected: RaiseColors.neutral500,
    hover: RaiseColors.neutral300,
    hoverText: RaiseColors.neutral500,
    background: RaiseColors.neutral300
  }
};
var useStyles = makeStyles(function () {
  return {
    root: {
      padding: "6px 16px",
      height: "32px",
      borderRadius: "20px",
      minWidth: "0px"
    },
    unselected: function unselected(_ref) {
      var colors = _ref.colors,
        variant = _ref.variant;
      return {
        borderColor: colors.unselected,
        borderWidth: variant === "enabled" || variant === "disabled" ? "0px" : "1px",
        color: colors.unselected,
        backgroundColor: colors.background,
        "&:hover": {
          color: colors.hoverText,
          backgroundColor: colors.hover,
          borderColor: colors.borderHover
        }
      };
    },
    selected: function selected(_ref2) {
      var colors = _ref2.colors,
        variant = _ref2.variant;
      return {
        borderColor: colors.selected,
        borderWidth: variant === "enabled" || variant === "disabled" ? "0px" : "2px",
        color: colors.selected,
        backgroundColor: colors.background
      };
    },
    menu: {
      boxShadow: "1px 0px 10px rgba(0, 0, 0, 0.25)",
      borderRadius: "4px",
      backgroundColor: RaiseColors.white,
      maxWidth: "200px",
      marginTop: "4px"
    },
    menuItem: {
      padding: "8px 16px",
      textAlign: "left",
      minHeight: "36px",
      "&:hover": {
        backgroundColor: RaiseColors.grayHover,
        "& p": {
          fontWeight: 600
        }
      }
    }
  };
});
var Pill = function Pill(_ref3) {
  var _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? "category" : _ref3$variant,
    leftIcon = _ref3.leftIcon,
    rightIcon = _ref3.rightIcon,
    isSelected = _ref3.isSelected,
    onClick = _ref3.onClick,
    children = _ref3.children,
    _ref3$customClass = _ref3.customClass,
    customClass = _ref3$customClass === void 0 ? null : _ref3$customClass,
    disabled = _ref3.disabled;
  var pillColors = PillVariantColors[variant];
  var classes = useStyles({
    colors: pillColors,
    variant: variant
  });
  return /*#__PURE__*/_jsx(Button, {
    variant: "secondaryButton",
    className: classNames(classes.root, customClass, isSelected ? classes.selected : classes.unselected),
    onClick: onClick,
    disableRipple: true,
    "data-testid": "category-button",
    disabled: disabled,
    children: /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        alignItems: "center"
      },
      children: [leftIcon && /*#__PURE__*/_jsx(Icon, {
        className: leftIcon,
        fontSize: 14,
        color: "inherit",
        style: {
          paddingRight: 8
        },
        "data-testid": "pill-left-icon"
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph_small"
        /// Needs to use inherit so the Typography component will use the hover colors when the parent element enters the hover state
        /// Defining a specific color here will override the parent hover state color.
        ,
        color: "inherit",
        weight: isSelected ? "bold" : "regular",
        "data-testid": "pill-body",
        children: children
      }), rightIcon && /*#__PURE__*/_jsx(Icon, {
        className: rightIcon,
        fontSize: 14,
        color: "inherit",
        style: {
          marginLeft: 8
        },
        "data-testid": "pill-right-icon"
      })]
    })
  });
};
export var MoreCategoriesPill = function MoreCategoriesPill(_ref4) {
  var categories = _ref4.categories,
    trackCategoryClick = _ref4.trackCategoryClick;
  var pillColors = PillVariantColors.category;
  var classes = useStyles({
    colors: pillColors,
    variant: "category"
  });
  var categoryLabel = "More Categories";
  var categoryObject = _findInstanceProperty(categories).call(categories, function (category) {
    return category.isSelected === true;
  });
  if (categoryObject) {
    categoryLabel = categoryObject.label;
  }
  return /*#__PURE__*/_jsx(Menu, {
    className: classes.menu,
    renderToggle: function renderToggle(props) {
      return /*#__PURE__*/_jsx(Button, {
        variant: "secondaryButton",
        className: classNames(classes.root, props.isOpen ? classes.selected : classes.unselected),
        onClick: function onClick(e) {
          if (trackCategoryClick) {
            trackCategoryClick("More Categories");
          }
          props.handleOpenClick(e);
        },
        disableRipple: true,
        "data-testid": "more-category-button",
        children: /*#__PURE__*/_jsxs(Typography, {
          variant: "paragraph_small",
          color: props.isOpen ? pillColors.selected : pillColors.unselected,
          weight: props.isOpen ? "bold" : "regular",
          style: {
            display: "flex"
          },
          children: [categoryLabel, /*#__PURE__*/_jsx(Icon, {
            className: "fal fa-chevron-down",
            style: {
              fontSize: "14px",
              paddingLeft: "6px",
              lineHeight: "inherit"
            },
            "data-testid": "more-categories-chevron"
          })]
        })
      });
    },
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    },
    children: _mapInstanceProperty(categories).call(categories, function (category, index) {
      return /*#__PURE__*/_jsx(MenuItem, {
        className: classes.menuItem,
        onClick: function onClick() {
          category.onClick();
          trackCategoryClick(category.label);
        },
        children: /*#__PURE__*/_jsx(Typography, {
          color: RaiseColors.black,
          children: category.label
        })
      }, index);
    })
  });
};
var ICON_WIDTH = 18.25;
export function getMoreCategoriesPillWidth() {
  return getCategoryPillWidth("More Categories") + ICON_WIDTH;
}
export default Pill;